import './Switch.scss';
import clsx from 'clsx';
import { constNull } from 'fp-ts/lib/function';
import React, { memo, ReactNode } from 'react';

type Props = {
  size?: 'sm' | 'md';
  kind?: 'primary' | 'secondary';
  disabled?: boolean;
  readOnly?: boolean;
  title?: ReactNode;
  valueActive?: ReactNode;
  valueInactive?: ReactNode;
  active: boolean;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  onLabelClick?: (e: React.MouseEvent<HTMLLabelElement, MouseEvent>) => void;
};

export const Switch = memo(({
  active,
  onChange,
  onLabelClick,
  size = 'md',
  kind = 'primary',
  disabled = false,
  readOnly = false,
  title,
  valueActive,
  valueInactive,
}: Props) => (
  <div className="bp-switch">
    {title && (
      <div className={clsx({
        'bp-switch__title': true,
        'bp-switch__title--disabled': disabled,
        'bp-switch__title--readonly': readOnly,
      })}
      >{title}
      </div>
    )}

    <div className="bp-switch__contents">
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control, jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions */}
      <label
        className={clsx({
          'bp-switch__label': true,
          'bp-switch__label--sm': size === 'sm',
        })}
        onClick={onLabelClick}
      >

        <input
          checked={active}
          onChange={readOnly ? constNull : onChange}
          className={clsx({
            'bp-switch__input': true,
            'bp-switch__input--secondary': kind === 'secondary',
          })}
          type="checkbox"
          disabled={disabled}
          readOnly={readOnly}
        />

        <span className={clsx({
          'bp-switch__slider': true,
          'bp-switch__slider--sm': size === 'sm',
          'bp-switch__slider--disabled': disabled,
          'bp-switch__slider--readonly': readOnly,
        })}
        />
      </label>

      {valueActive && valueInactive && (
        <div className="bp-switch__value">
          {active ? valueActive : valueInactive}
        </div>
      )}
    </div>
  </div>
));
